<template>
  <screen
    v-show="show"
    :screen-name="$t('stamp.tutorial.title')"
    :screen-info="$t('stamp.tutorial.feet_pos')"
    @skip="$emit('skip')"
  >
    <feet-mark />
  </screen>
</template>

<script>
import autoNext from '@/mixins/auto-next';

import Screen from '../Screen.vue';
import FeetMark from '../FeetMark.vue';

export default {
  name: 'FeetPos',
  components: {
    Screen,
    FeetMark,
  },
  mixins: [autoNext],
  data: () => ({
    duration: 6,
    playThrough: false,
    audioKey: 'v13_2',
  }),
};
</script>
